/** @format */
import { css } from 'styled-components';

const LINE_HEIGHT = '1.5em';
const BULLET_SIZE = 'var(--layout-spacing-4)';

const baseStyles = () => css`
    ul {
        display: flex;
        flex-direction: column;
        gap: var(--layout-spacing-8);
        padding: 0;
    }
    .additional-price-modifiers__list {
        margin-top: var(--layout-spacing-8);
    }

    li {
        display: inline-flex;
    }

    li::before {
        content: '';
        width: ${BULLET_SIZE};
        height: ${BULLET_SIZE};
        border-radius: 100%;
        background-color: var(--colors-surface-inverse);
        margin-top: calc((${LINE_HEIGHT} - ${BULLET_SIZE}) / 2);
        margin-right: var(--layout-spacing-8);
    }
`;

export const styles = () => css`
    ${baseStyles}
`;
